import { Notifier } from './notifier';

export class PriceManager extends Notifier {
  value: number;

  constructor() {
    super();
    document.querySelectorAll('.csl-right-side__priceItem').forEach((item) => {
      item.addEventListener('click', (event) => {
        const { value } = (event.target as HTMLElement).dataset;

        this.selectItem(Number(value));
      });
    });

    this.selectItem(100);
  }

  selectItem(value: number) {
    this.value = value;
    const activeElement = document.querySelector('.csl-right-side__priceItem--active');

    if (activeElement) {
      activeElement.classList.remove('csl-right-side__priceItem--active');
    }

    const priceItem = document.querySelector(`.csl-right-side__priceItem[data-value="${value}"]`);
    priceItem.classList.add('csl-right-side__priceItem--active');

    this.notifySubsciptions();
  }
}
